import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import EdapModuleView from '../EdapModuleView';
import { handleEdapClick } from '../../utils/edap';
import { MODULE_VIEW_EVENT_OPTIONS, OWNER_LYP_CLICK } from './events';

import './Lyp.less';

const CNAME = 'Lyp';

const Lyp = ({ title, callToActionText, callToActionUrl, imageUrl }) => (
  <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
    <div
      className={cnames(CNAME, 'jumbotron', 'jumbotron-inverse')}
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <div className={`${CNAME}__overlay`} />
      <div className="container">
        <h2 className={`${CNAME}__title`}>{title}</h2>
        {callToActionUrl && <button className="lyp__btn btn btn-lg btn-overlay">{callToActionText}</button>}
      </div>
      {callToActionUrl && <a onClick={handleEdapClick(OWNER_LYP_CLICK)} href={callToActionUrl} className={`${CNAME}__overlay-link`} />}
    </div>
  </EdapModuleView>
);

Lyp.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  btnText: PropTypes.string,
  callToActionUrl: PropTypes.string
};

export default Lyp;



// WEBPACK FOOTER //
// ./src/universal/components/Lyp/Lyp.js